import {AfterViewInit, Component, Input, input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {ActivatedRoute} from "@angular/router";
import {CommonModule} from "@angular/common";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ChartsComponent} from "../../../charts/charts/charts.component";
import {MatChipsModule} from "@angular/material/chips";
import {MatTooltipModule} from "@angular/material/tooltip";
import {PdfService} from "../../../../shared/services/pdfMake/pdf.service";


@Component({
  selector: 'app-statistic-list',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinner,
    ChartsComponent,
    TranslateModule,
    MatChipsModule,
    MatTooltipModule
  ],
  templateUrl: './statistic-list.component.html',
  styleUrl: './statistic-list.component.css'
})
export class StatisticListComponent implements OnInit, AfterViewInit, OnDestroy {
  sectionID = input<any>();
  productID = input<any>();
  selectedPeriod = input<any>();
  //selectedBenchmark = input<any>();

  productSlug!: any;

  productData: any;
  benchmarkData: any;
  statisticData!: any;
  chartData!: any;
  tableData!: any;
  customChartData!: any;
  isLoading: boolean = false;
  isCustomData: boolean = false;
  private _selectedBenchmark: any[] = [];


  private isAfterViewInit: boolean = false;

  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private _apiService: DjangoApiService,
    private _languageService: LanguageService,
    private _translate: TranslateService,
    private _route: ActivatedRoute,
    private _pdfService: PdfService) {
  }

  ngOnInit(): void {
    this.setupLanguageSubscription();
    this.subscribeToRouteParams();
    this.loadCustomData();
    console.log('Product ID', this.productID());
    console.log('Section ID', this.sectionID());
  }

  ngAfterViewInit() {
    this.isAfterViewInit = true;
  }

  @Input()
  set selectedBenchmark(value: any[]) {
    const newValue = value || [];
    if (JSON.stringify(this._selectedBenchmark) !== JSON.stringify(newValue)) {
      this._selectedBenchmark = [...newValue]; // Neue Referenz sicherstellen
      this.loadChartData();
    }
  }
  get selectedBenchmark(): any[] {
    return this._selectedBenchmark;
  }



  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }

  private subscribeToRouteParams(): void {
    this.subscriptions.add(
      this._route.paramMap.subscribe(params => {
        this.productSlug = this._route.snapshot.parent?.params['productSlug']
          this.loadProductData();
        //this.loadBenchmarkData(numericId);

      })
    );
  }


  private subscribeAndSetProperty(observable: Observable<any>, setter: (value: any) => void) {
    this.subscriptions.add(
      observable.subscribe({
        next: setter,
        error: (error) => {
          console.error('There was an error fetching data.', error);
        }
      })
    );
  }


  private loadProductData(): void {
    this.subscriptions.add(
      this._apiService.fetchProductDetail(this.productSlug).subscribe({
        next: (response: any) => {
          this.productData = response;
          //this.loadCustomData();
          //this.loadAllocationData();
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }

  private loadBenchmarkData(id: number): void {
    this.subscribeAndSetProperty(
      this._apiService.fetchBenchmarkList(id),
      (response: any) => {
        this.benchmarkData = response;
        this.loadCustomData();
        //this.loadAllocationData();
      }
    );
  }



  private loadCustomData() {
    this.subscribeAndSetProperty(
      this._apiService.fetchDataSourceList(this.sectionID(), this.productID()),
      (response: any) => {
        let customDataIsSelected = response.some((data:any) => this.isSectionSelected(data));

        if(customDataIsSelected){
          this.isCustomData = customDataIsSelected;
          this.customChartData = response.filter((data:any) => this.isSectionSelected(data));
          let chartData = {data: '', title: ''}
          chartData.data = this.customChartData[0].translations[this.currentLanguage].data_json;
          chartData.title = this.customChartData[0].translations[this.currentLanguage].title;
          this.chartData = chartData
        }
        this.loadAllocationData();
      }
    );
  }

  private loadAllocationData() {
    this.subscribeAndSetProperty(
      this._apiService.fetchAllocationListProcessed(this.sectionID(), this.productID()),
      (response: any) => {
        let customDataIsSelected = response.some((data:any) => this.isSectionSelected(data));

        if(customDataIsSelected){
          this.isCustomData = customDataIsSelected;
          this.customChartData = response.filter((data:any) => this.isSectionSelected(data));
          let chartData = {data: '', title: ''}
          chartData.data = this.customChartData[0].translations[this.currentLanguage].data_json;
          chartData.title = this.customChartData[0].translations[this.currentLanguage].title;
          this.chartData = chartData
        }
        this.loadStatisticData();
      }
    );
  }

  isSectionSelected(data: any): boolean {
    return data.section.includes(this.sectionID());
  }

  private loadStatisticData(): void {
    this.subscribeAndSetProperty(
      this._apiService.fetchStatisticList(this.sectionID()),
      (response: any) => {
        this.statisticData = response;
        if (!this.isCustomData && this.statisticData && this.statisticData.length > 0 && this.statisticData[0].frequency) {
          this.loadChartData();
        }
      }
    );
  }

  private loadChartData(): void {
    this.isLoading = true;
    //const benchmarkIDs = this.benchmarkData.map((item: any) => item.id);// Example benchmark IDs
    const benchmarkIDs = this.selectedBenchmark;
    const startDate = this.selectedPeriod()?.start_date;
    const endDate = this.selectedPeriod()?.end_date;
    let interval

    if (this.statisticData && this.statisticData.length > 0 && this.statisticData[0].frequency) {
      interval = this.statisticData[0].frequency
    }

    let statistic;

    if(this.statisticData && this.statisticData.length > 0){
      if(this.statisticData[0].statistics.length <= 1){
        statistic = this.statisticData[0].statistics[0].statistic_choice
      } else {
        const sortedData = this.statisticData[0].statistics.sort((a:any, b:any) => a.id - b.id);
        statistic = sortedData.map((item:any) => item.statistic_choice)
      }
    }


    this.subscriptions.add(
      this._apiService.fetchChartData(this.productID(), benchmarkIDs, startDate, endDate, interval, statistic).subscribe({
        next: (response: any) => {

          if(this.statisticData && this.statisticData.length > 0 && this.statisticData[0].chart === 'table' ){
            this.tableData = response;
            console.log('Table Data:', this.tableData);
            this._pdfService.initializeStatisticTable({id: this.sectionID(), data: this.tableData})
          } else {
            if(response?.product_data?.length > 0){
              this.chartData = response;
            }
          }
          this.isLoading = false;
        },
        error: (error) => {
          console.error('There was an error fetching chart data.', error);
          this.isLoading = false;
        }
      })
    );
  }

  shouldColorCell(row: string[], colIndex: number): boolean {
    if(this.productData?.phases[0]?.end_date){
      // Spalte 0 (Jahr) und evtl. die letzte Spalte (Ann.) nicht einfärben
      if (colIndex === 0 || colIndex === row.length - 1) {
        return false;
      }
      // Lese das Jahr aus der ersten Spalte der Zeile
      const year = parseInt(row[0], 10);
      // Spalte 1 entspricht Januar, 2 Februar, usw.
      const month = colIndex;
      // Erstelle ein Datum aus Jahr und Monat (Tag: 1)
      const cellDate = new Date(year, month - 1, 1);

      // Hole den Phasen-Zeitraum – hier gehen wir davon aus, dass productData.phases
      // ein Objekt mit den Eigenschaften "start" und "end" ist, z. B. "2020-01-01" bzw. "2074-07-31".
      const phaseStart = new Date(this.productData?.phases[0].start_date);
      const phaseEnd = new Date(this.productData?.phases[0].end_date);

      return cellDate >= phaseStart && cellDate <= phaseEnd;
    }
    return false;

  }

  hasColoredCell(row: string[]): boolean {
    if(this.productData?.phases[0]?.start_date) {
      // Prüfe alle Spalten (außer erster end_date letzter)
      for (let i = 1; i < row.length - 1; i++) {
        if (this.shouldColorCell(row, i)) {
          return true;
        }
      }
    }
    return false;
  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
